import types from 'store/types/courier';
import { API_PATHS } from 'helpers/endpoints';
import Requester from '../../helpers/requester';
import { HTTP_METHODS } from 'helpers/constants';

export default {
  getCourier: (queryString) => async (dispatch) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.COURIERS_SEARCH}?${queryString}`,
      });
      dispatch({ type: types.COURIER_SET, key: 'couriers', data: response });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getZones: (payload) => async (dispatch) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.ZONES_SEARCH}?${payload.queryString}&page=0&size=10000`,
      });
      dispatch({
        type: types.COURIER_SET,
        key: 'zones',
        data: response?._embedded?.zoneResponseDtoList,
      });
      return response?._embedded?.zoneResponseDtoList;
    } catch (error) {
      throw error;
    }
  },

  getCourierDashboardInfo: (payload) => {
    return Requester.submit({
      url: `${API_PATHS.COURIER_DASHBOARD}/${payload.slotId}/${payload.date}`,
    });
  },

  getCourierGpsData: (payload) => {
    return Requester.submit({
      method: HTTP_METHODS.POST,
      url: `${API_PATHS.GPS_LOCATIONS}/map-matched-gps-data`,
      data: payload,
    });
  },

  getCourierById: (id) => async (dispatch) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.COURIERS_SEARCH}?filter=id==${id}&page=0`,
      });
      const courier = response?._embedded?.courierResponseDtoList[0];
      dispatch({
        type: types.COURIER_SET,
        key: 'selectedCourier',
        data: courier,
      });
      return courier;
    } catch (error) {
      throw error;
    }
  },

  putCourierDocument: (payload) => {
    return Requester.submit({
      method: HTTP_METHODS.PUT,
      url: `${API_PATHS.COURIER_DOCUMENTS.replace('[id]', payload.id)}`,
      data: payload.data,
    });
  },

  editCourier: (payload) => async (dispatch) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.PATCH,
        url: `${API_PATHS.COURIERS}/${payload.id}`,
        data: {
          ...payload?.data,
          // some lines are hardcoded until business requirements arrived
          code: payload?.data?.phoneNumber,
        },
      });
      dispatch({
        type: types.COURIER_SET,
        key: 'selectedCourier',
        data: response,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  addCourier: (data) => async (dispatch) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.COURIERS}`,
        data: {
          ...data,
          // some lines are hardcoded until business requirements arrived
          code: data?.phoneNumber,
        },
      });
      dispatch({ type: types.COURIER_SET, key: 'addCourier', data: response });
      return response;
    } catch (error) {
      throw error;
    }
  },

  changeCourierStatus: (data) => async (dispatch) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.COURIERS}/change-courier-status`,
        data,
      });
      dispatch({
        type: types.COURIER_SET,
        key: 'changeCourierStatus',
        data: response,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getAllCouriers: (data) => async (dispatch) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.COURIERS}/zone/${data}`,
      });
      dispatch({ type: types.COURIER_SET, key: 'allCouriers', data: response });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getZonesByStoreId: (payload) => {
    return Requester.submit({
      method: HTTP_METHODS.GET,
      url: `${API_PATHS.ZONES_SEARCH}?${payload}&page=0&size=10000`,
    });
  },

  getDownloadLinkForCourier: async () => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.EXCEL_URL}/courier-template`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  getCourierTrackingDetails: (phoneNumber) => {
    return Requester.submit({
      method: HTTP_METHODS.GET,
      url: `${API_PATHS.COURIERS}/courier-tracking-detail/${phoneNumber}`,
    });
  },
  getCourierWithFilter: (payload, queryString) => {
    return Requester.submit({
      method: HTTP_METHODS.POST,
      url: `${API_PATHS.COURIERS_FILTER}?${queryString}`,
      data: payload,
    });
  },

  getCourierApplications: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.COURIER_APPLICATION_LIST}?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getCities: () => {
    try {
      const response = Requester.submit({
        url: `${API_PATHS.COURIER_LOCATIONS}/cities`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getDistricts: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.COURIER_LOCATIONS}/districts/${queryString}/city`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getNeighbourhoods: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.COURIER_LOCATIONS}/neighbourhoods/${queryString}/district`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getFilteredCourierApplications: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.FILTERED_COURIER_APPLICATION_LIST}?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getCouriers: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.COURIERS_SEARCH}?${queryString}`,
      });
      return response?._embedded?.courierResponseDtoList ?? [];
    } catch (error) {
      throw error;
    }
  },

  putCourierApprovalStatus: async (id, status) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.PUT,
        url: `${API_PATHS.COURIERS_STATUS}/${id}/${status}`,
      });
     return response;
    } catch (error) {
      throw error;
    }
  },

  rejectCourierApprovalStatus: async (id) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.COURIERS}/${id}/reject`,
      });
     return response;
    } catch (error) {
      throw error;
    }
  },

  downloadAllDocuments: async (id) => {
    try {
      window.location = `${API_PATHS.ALL_DOCUMENTS}?courierId=${id}`;
    } catch (error) {
      throw error;
    }
  },
};
